import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useState } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';

export default function TheComp() {
    const { t } = useLang('delta3series');
    const { locale = 'us' } = useRouter();
    const [active, setActive] = useState(0);

    const items = [
        {
            tab: t('F_tab1'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751007288719/indoor.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751008597646/indoor_M.png',
        },
        {
            tab: t('F_tab2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751007288970/outdoor.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751008597805/outdoor_M.png',
        },
    ];

    const [swiper, setSwiper] = useState<any>(null);
    const handleClickTab = (k: number) => {
        setActive(k);
        swiper.slideTo(k);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('F_title') || t('F_desc'),
            button_name: items[k].tab,
        });
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-m" />
            <p className="title">{t('F_title')}</p>
            <p className="subTitle">{t('F_subTitle')}</p>
            <p className="text">{t('F_desc')}</p>
            <Swiper
                className="items"
                modules={[Pagination]}
                onSlideChange={(swiper) => {
                    handleClickTab(swiper.activeIndex);
                }}
                onSwiper={(swiper) => setSwiper(swiper)}
                pagination
            >
                {items?.map((item: any, k: number) => (
                    <SwiperSlide className="item" key={k}>
                        <div className="item-img">
                            <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="tabs-box">
                <ul className="tabs">
                    {items?.map((tab: any, k: number) => (
                        <li className={`tab${active === k ? ' active' : ''}`} key={k} onClick={() => handleClickTab(k)}>
                            {tab.tab}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
